/* eslint-disable react/prop-types */
import ComposedViewElevenComponent from "./composed-view-eleven";

function ComposedViewEleven({ title, link }) {
  const handlePdfClick = () => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <ComposedViewElevenComponent title={title} onPdfClick={handlePdfClick} />
  );
}
export default ComposedViewEleven;
